import React, {forwardRef, useImperativeHandle, useRef} from "react";
import frameIcon from "../../../assets/icons/Frame.svg";
import ReactDragListView from "react-drag-listview";
import nextId from "react-id-generator";
import EachStock from "../eachStock/eachStock";
import { useSelector} from "react-redux";
import {collectionArray} from "./basketDetails";
import {ChildComponentRef,AllBaskets, BasketOrder} from "../../../models/basketOrders"

interface AllBasketOrderProps {
    basketOrders: BasketOrder[]; // Replace 'any' with the specific type for basket orders
    data: AllBaskets; // Replace with a more specific type if available
    masterOrder: any; // Replace with a specific type for master order
    isExecuted: boolean;
    updateBasketOrderCallBack: (orders: any[]) => void; // Replace 'any[]' with the type of basket orders
  }

const AllBasketOrderRef = forwardRef(({basketOrders,data,masterOrder,isExecuted,updateBasketOrderCallBack}: AllBasketOrderProps, ref) => {

    let dragProps = {
        onDragEnd(fromIndex:number, toIndex:number) {
            const data = [...basketOrders];
            const item = data.splice(fromIndex, 1)[0];
            data.splice(toIndex, 0, item);
            updateBasketOrderCallBack(data)
        },
        handleSelector: ".grab",
        nodeSelector:'.each_box',
        enableScroll:true,
    };
    const  listDataMain:AllBaskets[]  = useSelector((state:any) => state.basketOrder.listDataMain);

    const childRefEachStock = useRef<ChildComponentRef>(null)

    function setSingleExcData() {
        let orders:AllBaskets | undefined =  listDataMain.find((d:AllBaskets) => d.id === data.id)
        collectionArray.setBasketWhenExce = orders?.basketOrders
    }



    useImperativeHandle(ref, () => ({

        callChildMethod() {
            closeLodding()
        }

    }));


    function closeLodding() {
        childRefEachStock.current?.closeLodding();
    }

    if(basketOrders.length === 0){
        return (<div className="d-flex flex-column justify-content-start align-items-center">
            <div className=""><img src={frameIcon} alt={''}/></div>
            <div className="heading2 mt-5">No Stocks Found</div>
            <div className="text1 colorGrey currentColor">Search and Add upto 10 stocks in this basket</div>
        </div>);
    }

    return (

        <div className="d-flex flex-column justify-content-start align-items-start m-4">
            <div className="d-flex scroll_box2 my_scroll_track flex-column align-items-stretch w-100 justify-content-between">
                <ReactDragListView   {...dragProps}>
                    <table className="baskTable">
                        <thead className="card_bg">
                        <tr className="currentText">
                            <th>&nbsp;</th>
                            <th>Name</th>
                            <th>LTP</th>
                            <th>Price</th>
                            <th>Qty.</th>
                            <th>Status</th>
                        </tr>
                        </thead>

                        <tbody>
                        {
                            basketOrders.map((item:BasketOrder,index:number) => {
                                const id1 = nextId("BE-");
                                return(
                                    <EachStock ref={childRefEachStock} key={id1} data={item} index={index} masterOrder={masterOrder} isExecuted={isExecuted} setSingleExcData={setSingleExcData}/>
                                )
                            })
                        }
                        </tbody>

                    </table>
                </ReactDragListView>
            </div>
        </div>
    )
});



const AllBasketOrder = React.memo(AllBasketOrderRef);


export default AllBasketOrder;
